import React from 'react';
import { Component } from '@poa/core';
import { observable, autorun } from '@poa/state';
import Spinner from 'react-spinkit';
import Navbar from '../components/navbar';
import Chart, { EntityType } from '../components/charts/chart.component';
import moment from 'moment';

function createChart() {
  return {
    id: Math.random(),
    name: '',
    selectedEntityType: null,
    selectedEntityId: null,
    startDate: moment()
      .startOf('month')
      .hours(12),
    endDate: moment()
      .endOf('month')
      .hours(12),

    data: {
      entities: [],
      chartsData: null,
      loading: false
    }
  };
}

class ChartsPage extends React.Component {
  actions; // injected by Poa
  t; // injected by Poa

  localState = observable({
    loading: true,
    panels: [],
    managers: [],
    teamleads: [],
    charts: [createChart()]
  });

  getEntityDataByType(type) {
    switch (type) {
      case EntityType.manager:
        return this.localState.managers;
      case EntityType.panels:
        return this.localState.panels;
      case EntityType.teamleads:
        return this.localState.teamleads;
      default:
        return [];
    }
  }

  async componentDidMount() {
    // panels
    const panelsResponse = await this.env.http.get('panels');
    this.localState.panels = panelsResponse.data.map((panel, idx) => ({
      value: idx,
      label: panel
    }));

    // managers
    const managersResponse = await this.env.http.get('managers');
    this.localState.managers = managersResponse.data.map(manager => ({
      value: manager.id,
      label: `${manager.first_name} ${manager.last_name}`
    }));

    // teamleads
    const teamleadsResponse = await this.env.http.get('teamleads');
    this.localState.teamleads = teamleadsResponse.data.map(teamlead => ({
      value: teamlead.id,
      label: `${teamlead.first_name} ${teamlead.last_name}`
    }));

    // widget/?entity=manager&entityIds=1

    const charts = JSON.parse(window.localStorage.getItem('___test___'));
    if (charts && charts.length) {
      this.localState.charts = [];

      for (const chart of charts) {
        // if (!chart.selectedEntityType || !chart.selectedEntityId) {
        //   break;
        // }

        const params = {
          entity: chart.selectedEntityType,
          entityIds: chart.selectedEntityId,
          startDate: moment(chart.startDate).valueOf(),
          endDate: moment(chart.endDate).valueOf()
        };

        const widgetResponse = await this.env.http.get('widget', { params });

        this.localState.charts.push({
          id: chart.id,
          name: chart.name,
          selectedEntityType: chart.selectedEntityType,
          selectedEntityId: chart.selectedEntityId,
          startDate: moment(chart.startDate),
          endDate: moment(chart.endDate),

          data: {
            entities: this.getEntityDataByType(chart.selectedEntityType),
            chartsData: widgetResponse.data,
            loading: false
          }
        });
      }

      this.setAutoPersist();
    } else {
      this.setAutoPersist();
    }

    this.localState.loading = false;
  }

  setAutoPersist() {
    autorun(() => {
      window.localStorage.setItem(
        '___test___',
        JSON.stringify(
          this.localState.charts
            .map(chart => ({
              id: chart.id,
              name: chart.name,
              selectedEntityType: chart.selectedEntityType,
              selectedEntityId: chart.selectedEntityId,
              startDate: chart.startDate.format(),
              endDate: chart.endDate.format()
            }))
            .filter(chart => chart.selectedEntityId)
        )
      );
    });
  }

  getChartById(id) {
    return this.localState.charts.find(chart => chart.id === id);
  }

  onDatesChange = async (id, { startDate, endDate }) => {
    const chart = this.getChartById(id);

    chart.loading = true;

    try {
      if (startDate) {
        chart.startDate = startDate;
      }

      if (endDate) {
        chart.endDate = endDate;
      }

      if (!chart.selectedEntityId) {
        return;
      }

      const params = {
        entity: chart.selectedEntityType,
        entityIds: chart.selectedEntityId,
        startDate: moment(chart.startDate).valueOf(),
        endDate: moment(chart.endDate).valueOf()
      };

      const widgetResponse = await this.env.http.get('widget', { params });

      chart.data.chartsData = widgetResponse.data;
    } catch (e) {
    } finally {
      chart.data.loading = false;
    }
  };

  onEntitySelect = async (id, value) => {
    const chart = this.getChartById(id);

    chart.selectedEntityId = value;
    const params = {
      entity: chart.selectedEntityType,
      entityIds: chart.selectedEntityId,
      startDate: moment(chart.startDate).valueOf(),
      endDate: moment(chart.endDate).valueOf()
    };

    const widgetResponse = await this.env.http.get('widget', { params });
    chart.data.chartsData = widgetResponse.data;
  };

  onEntityTypeSelect = (id, type) => {
    const chart = this.getChartById(id);

    chart.data.entities = this.getEntityDataByType(type);
    chart.selectedEntityType = type;
    chart.selectedEntityId = null;
    chart.data.chartsData = null;
  };

  onEntityClose = id => {
    const chart = this.getChartById(id);
    if (chart.selectedEntityId) {
      // TODO: start fetching data??
    }
  };

  onDelete = id => {
    const idx = this.localState.charts.findIndex(chart => chart.id === id);
    this.localState.charts.splice(idx, 1);
  };

  render() {
    return (
      <div className="content charts">
        <div className="">
          <Navbar />
          <div
            style={{
              height: 'calc(100vh - 66px)',
              overflowY: 'scroll',
              // alignItems: 'center',
              // justifyItems: 'center',
              // justifyContent: 'space-evenly',
              // gridRowGap: '60px',
              // gridColumnGap: '0px',
              paddingTop: '40px',
              paddingBottom: '40px',
              // display: 'grid',
              // gridTemplateColumns: 'repeat(auto-fit, minmax(750px, 1fr))',
              backgroundImage: 'linear-gradient(45deg, #0c5091 0%, #571d67 100%)'
            }}
          >
            {' '}
            {this.localState.loading ? (
              <Spinner name="folding-cube" fadeIn="none" />
            ) : (
              <React.Fragment>
                {this.localState.charts.map(chart => (
                  <Chart
                    key={chart.id}
                    {...chart}
                    onDatesChange={(...args) => this.onDatesChange(chart.id, ...args)}
                    onEntitySelect={(...args) => this.onEntitySelect(chart.id, ...args)}
                    onEntityTypeSelect={(...args) => this.onEntityTypeSelect(chart.id, ...args)}
                    onEntityClose={() => this.onEntityClose(chart.id)}
                    onDelete={() => this.onDelete(chart.id)}
                  />
                ))}
                <div
                  className="authorization__box"
                  style={{
                    width: 'calc(100% - 100px)',
                    height: '520px',
                    marginBottom: '50px',
                    marginLeft: '50px',
                    padding: 25,
                    background: 'transparent',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 150,
                    color: 'green'
                  }}
                  onClick={() => this.localState.charts.push(createChart())}
                >
                  +
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Component({ namespaces: ['charts'] })(ChartsPage);
